import React from 'react';
import InnerTargetField from '../InnerTargetField';
import ContextModels from './ContextModels';
import { useWatch } from 'react-hook-form';
import ContextTypeField from './ContextTypeField';

const TargetFieldDataForContext = ({ fieldName, readOnly }) => {
  const selectedContextModel = useWatch({
    name: fieldName,
  });

  return (
    <>
      <ContextModels fieldName={fieldName} readOnly={readOnly}/>
      {selectedContextModel ? (
        <ContextTypeField fieldName={fieldName} readOnly={readOnly}/>
      ) : (
        <></>
      )}
      <InnerTargetField fieldName={fieldName} readOnly={readOnly}/>
    </>
  );
};

export default TargetFieldDataForContext;
